import { RequestApi } from "../../../api/request";
import { DateFormats } from "../../../constants/dateFormats";
import { throwErrorToastAsync } from "../../../services/throwErrorToast";
import { getLocalDate } from "../../../utils/dateUtils";
import { setGlobalLoading } from "../../reducers/globalLoading/globalLoading";
import { setLoadingCreateRequest } from "../../reducers/request/create/form";
import {
    resetDetailsRequestForm,
    setIsLoadedRequestDetail,
    setLoadingRequestDetails,
    setRequestDetailsFormData,
} from "../../reducers/request/detail/form";
import { setLoadingRequestList, setRequestListData } from "../../reducers/request/list/list";
import { AppThunk, store } from "../../store";

const api = new RequestApi();

export const fetchRequestList = (): AppThunk => async (dispatch) => {
    try {
        dispatch(setGlobalLoading(true));
        dispatch(setLoadingRequestList(true));
        const response = await api.getRequestListList();
        dispatch(setRequestListData(response));
    } catch (error) {
        throwErrorToastAsync(error);
    } finally {
        dispatch(setGlobalLoading(false));
    }
};

export const fetchRequestItem = (id: any): any => {
    return async (dispatch: any) => {
        try {
            dispatch(resetDetailsRequestForm());
            dispatch(setLoadingRequestDetails(true));
            const response = await api.getRequestItem(id);
            if (response) {
                dispatch(setRequestDetailsFormData(response));
                dispatch(setIsLoadedRequestDetail(true));
            } else {
                dispatch(
                    setRequestDetailsFormData({
                        dockCode: "",
                        dockDescription: "",
                        dockEndOn: "",
                        dockStartOn: "",
                        entryOn: "",
                        date: "",
                        newSeals: [],
                        originSeals: [],
                        stateDescription: "",
                        stateSort: 0,
                        transportUnitNumber: "",
                        id: id,
                        reloadrequest: true,
                    }),
                );
            }
            return true;
        } catch (error) {
            throwErrorToastAsync(error);

            return false;
        } finally {
            dispatch(setLoadingRequestDetails(false));
            dispatch(setGlobalLoading(false));
        }
    };
};

export const addNewRequest = (): ((dispatch: any) => Promise<{ success: boolean; withMessage: any }>) => {
    return async (dispatch: any): Promise<{ success: boolean; withMessage: any }> => {
        dispatch(setLoadingCreateRequest(true));
        dispatch(setGlobalLoading(true));

        try {
            const { form } = store.getState().addRequestForm;
            const newForm = {
                date: getLocalDate(DateFormats.ISO),
                transportUnitNumber: form.transportUnitNumber,
            };

            await api.patchAddRequest(newForm);
            dispatch(fetchRequestList());
            return { success: true, withMessage: null };
        } catch (error) {
            throwErrorToastAsync(error);
            return { success: false, withMessage: error };
        } finally {
            dispatch(setLoadingCreateRequest(false));
            dispatch(setGlobalLoading(false));
        }
    };
};
